import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Select, Row, Col, DatePicker, Form } from 'antd';
import '../normalsearch.css';
import { registersuccess } from '../../SweetAlert/SweetAlert';
import { WarningAlert } from '../Base UI Elements/SweetAlert';
import { getProfileShortListingDetails, uplaodProfileShortListingDetails } from '../../HttpRequest/issues';
import { userInformation } from '../../HttpRequest/userdetails';

const { Option } = Select;

const ProfileShortlisting = () => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const userId = localStorage.getItem("id");
  const [userFullName, setUserFullName] = useState('');

  const [formValues, setFormValues] = useState({
    studentName: '',
    country: '',
    degree: '',
    course: '',
    interScore: '',
    bachelorsPassOut: null,
    bachelorScore: '',
    backlogs: '',
    workExperience: '',
    englishTest: '',
    englishTestScore: '',
  });  
  const handleOpenModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const handleInputChange = (field, value) => {
    const parsedValue = parseFloat(userId);
    setFormValues({
      ...formValues,
      [field]: value,
      userId: parsedValue, 
      status: "Open",
    });
  };

  const handleFormSubmit = () => {
    form.validateFields().then(() => {
      console.log('Form submitted:', formValues);
       uplaodProfileShortListingDetails(formValues).then((response)=>{

      console.log("uplaodProfileShortListingDetails Response==>",response.data);
      try{
        setVisible(false);
      form.resetFields();
      setFormValues({
        studentName: '',
        country: '',
        degree: '',
        course: '',
        interScore: '',
        bachelorsPassOut: null,
        bachelorScore: '',
        backlogs: '',
        workExperience: '',
        englishTest: '',
        englishTestScore: '',
      });
      registersuccess("Successfully requested for the profile shortlisting");
      }catch{
        WarningAlert("Some thing went Wrong Please contact admin...");
        console.log("Form submit failure for the profile short listing");
      }   })   
    }).catch((errors) => {
      const newErrors = {};
      errors.errorFields.forEach(({ name, errors }) => {
        newErrors[name[0]] = errors[0];
      });
    });
  };

  return (
    <>
      <Button
        style={{
          background: '#3F5FD6',
          color: 'white',
        }}
        onClick={handleOpenModal}
      >
        Get Help in Profile Shortlisting
      </Button>
      <Modal
        title={<span className="modal-title">Get Help in Profile Shortlisting</span>}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        <Form form={form}>
          <div className="profileShortListingdiv">
            <p className="profileShortListingp">Student Name*</p>
            <Form.Item
              name="studentName"
              rules={[{ required: true, message: 'Student Name is required' }]}
            >
              <Input
                placeholder="Enter your name"
                onChange={(e) => handleInputChange('studentName', e.target.value)}
                // defaultValue={userFullName}
                // disabled             
                
              />
            </Form.Item>
          </div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Country</p>
                <Form.Item
                  name="country"
                  rules={[{ required: true, message: 'Country is required' }]}
                >
                  <Select
                    placeholder="Select Country"
                    style={{ width: '60%', border: '1px solid #d9d9d9', borderRadius: '7px' }}  
                    onChange={(value) => handleInputChange('country', value)}
                  >
                    <Option value="United Kingdom">United Kingdom</Option>
                      <Option value="United States Of America">
                        United States Of America
                      </Option>
                      <Option value="Canada">Canada</Option>
                      <Option value="Australia">Australia</Option>
                      <Option value="Finland">Finland</Option>
                      <Option value="New Zealand">New Zealand</Option>
                  </Select>
                </Form.Item>
            </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Degree</p>
                <Form.Item
                  name="degree"
                  rules={[{ required: true, message: 'Degree is required' }]}
                >
                  <Select
                    placeholder="Select Degree"
                    style={{ width: '60%', border: '1px solid #d9d9d9', borderRadius: '7px' }}  
                    onChange={(value) => handleInputChange('degree', value)}
                  >
                          <Option value="Postgraduate">Postgraduate</Option>
                          <Option value="Undergraduate">Undergraduate</Option>
                          <Option value="PhD">PHD</Option>
                          <Option value="English">English[ESL,IEP,ELP]</Option>
                  </Select>
                </Form.Item>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Course/Program</p>
                <Form.Item
                  name="course"
                  rules={[{ required: true, message: 'Course is required' }]}
                >
                  <Input
                    placeholder="Enter your desired course"
                    onChange={(e) => handleInputChange('course', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">12th Score</p>
                <Form.Item
                  name="interScore"
                  rules={[{ required: true, message: '12th Score is required' }]}
                >
                  <Input
                    placeholder="Enter your 12th score"
                    onChange={(e) => handleInputChange('interScore', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Year of Bachelor Graduation</p>
                <Form.Item
                  name="bachelorsPassOut"
                //   rules={[{ required: true, message: 'Year of Bachelor Graduation is required' }]}
                >
                  <DatePicker
                    placeholder="Select the year of graduation"
                    style={{ width: '100%' }}
                    inputReadOnly={true}
                    onChange={(date, dateString) => handleInputChange('bachelorsPassOut', dateString)}
                    />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Bachelor's Score</p>
                <Form.Item
                  name="bachelorScore"
                //   rules={[{ required: true, message: "Bachelor's Score is required" }]}
                >
                  <Input
                    placeholder="Enter your Bachelor's score"
                    onChange={(e) => handleInputChange('bachelorScore', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Backlogs</p>
                <Form.Item
                  name="backlogs"
                >
                  <Input
                    placeholder="Enter the number of backlogs (if any)"
                    onChange={(e) => handleInputChange('backlogs', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Work Experience</p>
                <Form.Item
                  name="workExperience"
                >
                  <Input
                    placeholder="Enter your work experience details (if any)"
                    className="create-application-input"
                    onChange={(e) => handleInputChange('workExperience', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Professional English Test</p>
                <Form.Item
                  name="englishTest"
                  rules={[{ required: true, message: 'Type of English Test is required' }]}
                >
                  <Input
                    placeholder="Did you take a professional English test? If yes, provide details."
                    onChange={(e) => handleInputChange('englishTest', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="profileShortListingdiv">
                <p className="profileShortListingp">Score in the English Test</p>
                <Form.Item
                  name="englishTestScore  "
                  rules={[{ required: true, message: 'Score of English Test is required' }]}
                >
                  <Input
                    placeholder="Enter your score in the English test"
                    onChange={(e) => handleInputChange('englishTestScore', e.target.value)}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
          <div className='d-flex' style={{justifyContent: 'end'}}>
            <div>
            </div>
            <div>
            <Button
            style={{
              background: '#3F5FD6',
              color: 'white',
            }}
            onClick={handleFormSubmit}
          >
            Submit
          </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ProfileShortlisting;
